import React from 'react'
import { Link, Navigate } from 'react-router-dom'
import Store from './reduxdata/Store'
import { connect } from 'react-redux'
import { ACTION_LOGOUT } from './reduxdata/actions/UserAction'
var mapStateToProps = (state) => {
    return {
        loginstatus: state.loginstatus,
        userName: state.userName,
        usertype: state.type
    }
}
class Menu extends React.Component {
    constructor() {
        super()
        this.state =
        {
            islogout: false
        }
    }
    logout = () => {
        Store.dispatch({
            ...ACTION_LOGOUT
        })
    }
    render() {
        if (this.state.islogout)
            return <Navigate to='/' />
        else 
        return <>
            {this.props.loginstatus ?
                <> 
                <header id="header" className="header fixed-top d-flex align-items-center">

<div className="d-flex align-items-center justify-content-between">
  <a href="index.html" className="logo d-flex align-items-center">
    <img src="assets/img/logo.png" alt=""/>
    <span className="d-none d-lg-block">Quick-Service</span>
  </a>
  <i className="bi bi-list toggle-sidebar-btn"></i>
</div>

<div className="search-bar">
  <form className="search-form d-flex align-items-center" method="POST" action="#">
    <input type="text" name="query" placeholder="Search" title="Enter search keyword"/>
    <button type="submit" title="Search"><i className="bi bi-search"></i></button>
  </form>
</div>

<nav className="header-nav ms-auto">
  <ul className="d-flex align-items-center">

    <li className="nav-item d-block d-lg-none">
      <Link className="nav-link nav-icon search-bar-toggle " to="#">
        <i className="bi bi-search"></i>
      </Link>
    </li>
    <li className="nav-item dropdown">

      <Link className="nav-link nav-icon" to="#" data-bs-toggle="dropdown">
        <i className="bi bi-bell"></i>
        <span className="badge bg-primary badge-number">4</span>
      </Link>
      <Link className="nav-link collapsed" to="/Home" onClick={this.logout}>
                                    <i className="bi bi-box-arrow-in-right"></i>
                                    <span>LogOut</span>
                                </Link>
      <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications">
        <li className="dropdown-header">
          You have 4 new notifications
          <Link to="#"><span className="badge rounded-pill bg-primary p-2 ms-2">View all</span></Link>
        </li>
        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li className="notification-item">
          <i className="bi bi-exclamation-circle text-warning"></i>
          <div>
            <h4>Lorem Ipsum</h4>
            <p>Quae dolorem earum veritatis oditseno</p>
            <p>30 min. ago</p>
          </div>
        </li>

        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li className="notification-item">
          <i className="bi bi-x-circle text-danger"></i>
          <div>
            <h4>Atque rerum nesciunt</h4>
            <p>Quae dolorem earum veritatis oditseno</p>
            <p>1 hr. ago</p>
          </div>
        </li>

        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li className="notification-item">
          <i className="bi bi-check-circle text-success"></i>
          <div>
            <h4>Sit rerum fuga</h4>
            <p>Quae dolorem earum veritatis oditseno</p>
            <p>2 hrs. ago</p>
          </div>
        </li>

        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li className="notification-item">
          <i className="bi bi-info-circle text-primary"></i>
          <div>
            <h4>Dicta reprehenderit</h4>
            <p>Quae dolorem earum veritatis oditseno</p>
            <p>4 hrs. ago</p>
          </div>
        </li>

        <li>
          <hr className="dropdown-divider"/>
        </li>
        <li className="dropdown-footer">
          <Link to="#">Show all notifications</Link>
        </li>

      </ul>

    </li>

    <li className="nav-item dropdown">

      <Link className="nav-link nav-icon" to="#" data-bs-toggle="dropdown">
        <i className="bi bi-chat-left-text"></i>
        <span className="badge bg-success badge-number">3</span>
      </Link>

      <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow messages">
        <li className="dropdown-header">
          You have 3 new messages
          <Link to="#"><span className="badge rounded-pill bg-primary p-2 ms-2">View all</span></Link>
        </li>
        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li className="message-item">
          <Link to="#">
            <img src="assets/img/messages-1.jpg" alt="" className="rounded-circle"/>
            <div>
              <h4>Maria Hudson</h4>
              <p>Velit asperiores et ducimus soluta repudiandae labore officia est ut...</p>
              <p>4 hrs. ago</p>
            </div>
          </Link>
        </li>
        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li className="message-item">
          <Link to="#">
            <img src="assets/img/messages-2.jpg" alt="" className="rounded-circle"/>
            <div>
              <h4>Anna Nelson</h4>
              <p>Velit asperiores et ducimus soluta repudiandae labore officia est ut...</p>
              <p>6 hrs. ago</p>
            </div>
          </Link>
        </li>
        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li className="message-item">
          <Link to="#">
            <img src="assets/img/messages-3.jpg" alt="" className="rounded-circle"/>
            <div>
              <h4>David Muldon</h4>
              <p>Velit asperiores et ducimus soluta repudiandae labore officia est ut...</p>
              <p>8 hrs. ago</p>
            </div>
          </Link>
        </li>
        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li className="dropdown-footer">
          <Link to="#">Show all messages</Link>
        </li>

      </ul>

    </li>

    <li className="nav-item dropdown pe-3">

      <Link className="nav-link nav-profile d-flex align-items-center pe-0" to="#" data-bs-toggle="dropdown">
        <img src="assets/img/profile-img.jpg" alt="Profile" className="rounded-circle"/>
        <span className="d-none d-md-block dropdown-toggle ps-2">Chetan Kumayu</span>
      </Link>

      <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
        <li className="dropdown-header">
          <h6>Chetan Kumayu</h6>
          <span>Web Developer</span>
        </li>
        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li>
          <Link className="dropdown-item d-flex align-items-center" to="/Profile">
            <i className="bi bi-person"></i>
            <span>My Profile</span>
          </Link>
        </li>
        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li>
          <Link className="dropdown-item d-flex align-items-center" to="/Profile">
            <i className="bi bi-gear"></i>
            <span>Account Settings</span>
          </Link>
        </li>
        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li>
          <Link className="dropdown-item d-flex align-items-center" to="/AdminContact">
            <i className="bi bi-question-circle"></i>
            <span>Need Help?</span>
          </Link>
        </li>
        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li>
          <Link className="dropdown-item d-flex align-items-center" to="#">
            <i className="bi bi-box-arrow-right"></i>
            <span>Sign Out</span>
          </Link>
        </li>

      </ul>
    </li>

  </ul>
</nav>

</header>

                    <aside id="sidebar" className="sidebar">

                        <ul className="sidebar-nav" id="sidebar-nav">
                            {this.props.usertype == 'Admin' ?
                            
                                <li class="nav-item">
                                    <Link class="nav-link page-scroll" to="">Home</Link>
                                </li> : ""}
                            {this.props.usertype == 'Admin' ?
                                <li className="nav-item">
                                    <Link className="nav-link " to="">
                                        <i className="bi bi-grid"></i>
                                        <span>Dashboard</span>
                                    </Link>
                                </li> : ""}
                            {this.props.usertype == 'Admin' ?
                                <li className="nav-item">
                                    <Link className="nav-link collapsed" data-bs-target="#components-nav" data-bs-toggle="collapse" to="#">
                                        <i className="bi bi-menu-button-wide"></i><span>Services</span><i className="bi bi-chevron-down ms-auto"></i>
                                    </Link>
                                    <ul id="components-nav" className="nav-content collapse " data-bs-parent="#sidebar-nav">
                                        <li>
                                            <Link to="/addCategory">
                                                <i className="bi bi-circle"></i><span> Service Category </span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/addBrand">
                                                <i className="bi bi-circle"></i><span>Service Type</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/addProduct">
                                                <i className="bi bi-circle"></i><span>User List</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/OrderRequest">
                                                <i className="bi bi-circle"></i><span>Order Request</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </li> : ""}
                          
                                         <li className="nav-heading">Pages</li>
                                         {this.props.usertype == 'Admin' ?
                                        <li className="nav-item">
                                       <Link className="nav-link collapsed" to="/Profile">
                                      <i className="bi bi-person"></i>
                                        <span>Profile</span>
                                        </Link>
                                      </li> : ""}

                                      {this.props.usertype == 'Admin' ?

                            <li className="nav-item">
                                <Link className="nav-link collapsed" to="/AdminContact">
                                    <i className="bi bi-envelope"></i>
                                    <span>Contact</span>
                                </Link>
                            </li>:""}


                            {this.props.usertype == 'Admin' ?
                            <li className="nav-item">
                                <Link className="nav-link collapsed" to="/Home" onClick={this.logout}>
                                    <i className="bi bi-box-arrow-in-right"></i>
                                    <span>LogOut</span>
                                </Link>
                            </li>:""}
                            
                            {/* {this.props.usertype == 'User' ? asdfghj:""} */}

                        </ul>

                    </aside>


                </> : 
                <>
                <div className="container-fluid">
        <div className="row">
            <div className="col-mg-3 bg-dark d-none d-lg-block">
                <br/>
                <Link to="" className="navbar-brand w-810 h-80 m-0 p-0 d-flex align-items-center justify-content-center">
                    <h1 className="m-0 display-2 text-primary p-2" style={{ fontSize: 50 }}>Quick</h1>
                    <h1 className="m-0 display-2 text-primary p-2" style={{ fontSize: 50 }}>Serve</h1>
                   
                </Link>
            </div>
            <div className="col-lg-9">
                <div className="row bg-dark d-none d-lg-flex">
                    <div className="col-lg-7 text-left text-white">
                        <div className="h-100 d-inline-flex align-items-center border-right border-primary py-2 px-3">
                            <i className="fa fa-envelope text-primary mr-2"></i>
                            <small>info@example.com</small>
                        </div>
                        <div className="h-100 d-inline-flex align-items-center py-2 px-2">
                            <i className="fa fa-phone-alt text-primary mr-2"></i>
                            <small>+012 345 6789</small>
                        </div>
                    </div>
                    <div className="col-lg-5 text-right">
                        <div className="d-inline-flex align-items-center pr-2">
                            <Link className="text-primary p-2" to="">
                                <i className="fab fa-facebook-f"></i>
                            </Link>
                            <Link className="text-primary p-2" to="https://twitter.com/chetan_kumayu?t=37XDQMfRsc-AQ0Eh0Gx7YA&s=09">
                                <i className="fab fa-twitter"></i>
                            </Link>
                            <Link className="text-primary p-2" to="https://www.linkedin.com/in/%F0%9D%99%B2%F0%9D%99%B7%F0%9D%99%B4%F0%9D%9A%83%F0%9D%99%B0%F0%9D%99%BD-%F0%9D%9A%94%F0%9D%9A%9E%F0%9D%9A%96%F0%9D%9A%8A%F0%9D%9A%A2%F0%9D%9A%9E-79b74724a">
                                <i className="fab fa-linkedin-in"></i>
                            </Link>
                            <Link className="text-primary p-2" to="https://instagram.com/24_chetan_kumayu?igshid=YmMyMTA2M2Y=">
                                <i className="fab fa-instagram"></i>
                            </Link>
                            <Link className="text-primary p-2" to="">
                                <i className="fab fa-youtube"></i>
                            </Link>
                        </div>
                    </div>
                </div>
                <nav className="navbar navbar-expand-lg bg-white navbar-light p-0">
                    <Link to="" className="navbar-brand d-block d-lg-none">
                        <h1 className="m-0 display-4 text-primary">Serve</h1>
                    </Link>
                    <button type="button" className="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse justify-content-between" id="navbarCollapse">
                        <div className="navbar-nav mr-auto py-0">
                            <Link to="/" className="nav-item nav-link active">Home</Link>
                            <Link to="/About" className="nav-item nav-link">About</Link>
                            <Link to="#" className= "nav-link dropdown-toggle" data-toggle="dropdown">Services</Link>
                            <div className="dropdown-menu rounded-0 m-0">
                                    <Link to="/Cleaning" className="dropdown-item">Cleaning Services</Link>
                                    <Link to="/Carpenter" className="dropdown-item">Carpenter Services</Link>
                                    <Link to="/Plumbing" className="dropdown-item">Plumbing Services</Link>
                                    <Link to="/Electrician" className="dropdown-item">Electrician  Services</Link>
                                </div>
                            <Link to="/Booking" className="nav-item nav-link">MyBooking</Link>
                        
                            <Link to="/Contact" className="nav-item nav-link">Contact</Link> 
                        </div>
                        <li className="nav-item dropdown">

<Link className="nav-link nav-icon" to="/Notification" data-bs-toggle="dropdown">
  <i className="bi bi-bell"></i>
  <span className="badge bg-dark badge-number">4</span>
</Link>

<ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications">
  <li className="dropdown-header">
    You have 4 new notifications
    <Link to="/Notification"><span className="badge rounded-pill bg-primary p-2 ms-2">View all</span></Link>
  </li>
 
  <li>
    <hr className="dropdown-divider"/>
  </li>
  <li className="dropdown-footer">
    <Link to="#">Show all notifications</Link>
  </li>

</ul>

</li>

                        <a href="/Login" class="btn btn-primary mr-3 d-none d-lg-block">LOGIN</a>
                    </div>
                </nav>
            </div>
        </div>
    </div>
            
                
                </>}

        </>

}}
export default connect(mapStateToProps)(Menu)